import { render, staticRenderFns } from "./flowmeter-detail.vue?vue&type=template&id=0f23f5d8&scoped=true"
import script from "./flowmeter-detail.vue?vue&type=script&lang=js"
export * from "./flowmeter-detail.vue?vue&type=script&lang=js"
import style0 from "./flowmeter-detail.vue?vue&type=style&index=0&id=0f23f5d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f23f5d8",
  null
  
)

export default component.exports